import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import './studioTrialBannerUpdate.scss';
import studioTrialBannerUpdateView from './studioTrialBannerUpdateView.html';
let StudioTrialBannerUpdateComponent = class StudioTrialBannerUpdateComponent {
    constructor() {
        this.$onInit = () => {
            if (this.isEnabled === undefined) {
                this.isEnabled = true;
            }
        };
        this.$onChanges = (changes) => {
            if (changes.isEnabled && !changes.isEnabled.isFirstChange()) {
                this.isEnabled = changes.isEnabled.currentValue;
            }
        };
        this.handleUpgradePlan = () => {
            if (this.onUpgradePlan) {
                this.onUpgradePlan();
            }
        };
    }
};
StudioTrialBannerUpdateComponent = __decorate([
    Component({
        template: studioTrialBannerUpdateView,
        controllerAs: '$ctrl',
        bindings: {
            isEnabled: '<',
            onUpgradePlan: '&',
        },
    }),
    __metadata("design:paramtypes", [])
], StudioTrialBannerUpdateComponent);
export { StudioTrialBannerUpdateComponent };
